<template>
  <div>
    <a-card :bordered="false" title="科目汇总表">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24"><a-form-item label="起始月份" :labelCol="labelCol" :wrapperCol="wrapperCol"><a-month-picker v-model="beginMoment" format="YYYY-MM" style="width:100%" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="截止月份" :labelCol="labelCol" :wrapperCol="wrapperCol"><a-month-picker v-model="endMoment" format="YYYY-MM" style="width:100%" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="门店" :labelCol="labelCol" :wrapperCol="wrapperCol"><store-tenant-select domain="finance" @change="handleStoreTenantChange"></store-tenant-select></a-form-item></a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery">查询</a-button>
                <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table bordered size="middle" rowKey="key" :columns="columns" :dataSource="tableData" :pagination="false" :loading="loading" :rowClassName="rowClassName" :scroll="tableScroll" />
      <div v-if="list.length" style="margin-top: 8px;">
        借贷合计校验：<span :style="{ color: totalOk ? '#52c41a' : '#f5222d' }">合计借方{{ totalOk ? '=' : '≠' }}合计贷方</span>
      </div>
    </a-card>
  </div>
</template>

<script>
import moment from 'moment'
import { ledgerSubjectBalance, accountSetCurrent } from './api'
import StoreTenantSelect from '@/components/StoreTenantSelect'

const fmt2 = v => (v === null || v === undefined || v === '' || isNaN(Number(v))) ? '' : Number(v).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

export default {
  name: 'SubjectSummaryList',
  components: { StoreTenantSelect },
  data() {
    return {
      labelCol: { span: 6 }, wrapperCol: { span: 17, offset: 1 },
      accountSetId: null, beginMoment: null, endMoment: null, loading: false,
      list: [],
      tableScroll: { x: 'max-content', y: 400 }
    }
  },
  computed: {
    columns() {
      return [
        { title: '科目编码', dataIndex: 'subject_code', width: 140 },
        { title: '科目名称', dataIndex: 'subject_name' },
        { title: '金额合计', children: [
          { title: '借方', dataIndex: 'debitAmount', align: 'right', width: 140 },
          { title: '贷方', dataIndex: 'creditAmount', align: 'right', width: 140 }
        ] }
      ]
    },
    numTotals() {
      const sum = (f) => this.list.reduce((a, r) => a + (Number(r[f]) || 0), 0)
      return { debit: sum('debitAmount'), credit: sum('creditAmount') }
    },
    tableData() {
      const rows = this.list.map((r, i) => ({
        key: r.id || ('r' + i), subject_code: r.subject_code, subject_name: r.subject_name,
        debitAmount: fmt2(r.debitAmount), creditAmount: fmt2(r.creditAmount)
      }))
      if (rows.length) {
        rows.push({ key: '__total__', subject_code: '', subject_name: '合计', isTotal: true,
          debitAmount: fmt2(this.numTotals.debit), creditAmount: fmt2(this.numTotals.credit) })
      }
      return rows
    },
    totalOk() { return Math.abs(this.numTotals.debit - this.numTotals.credit) < 0.005 }
  },
  created() {
    this.beginMoment = moment()
    this.endMoment = moment()
    this.loadCurrent()
  },
  mounted() {
    this.$nextTick(() => {
      const el = this.$el.querySelector('.ant-table')
      if (el) {
        const top = el.getBoundingClientRect().top
        this.tableScroll.y = Math.max(300, window.innerHeight - top - 24)
      }
    })
  },
  methods: {
    loadCurrent() {
      accountSetCurrent({}).then((res) => {
        if (res && res.success && res.data && res.data.id) { this.accountSetId = res.data.id; this.searchQuery() } else { this.$message.warning('尚未建账') }
      })
    },
    searchQuery() {
      this.loading = true
      const beginPeriod = this.beginMoment ? this.beginMoment.format('YYYY-MM') : null
      const endPeriod = this.endMoment ? this.endMoment.format('YYYY-MM') : null
      ledgerSubjectBalance({ accountSetId: this.accountSetId, beginPeriod: beginPeriod, endPeriod: endPeriod }).then((res) => {
        if (res && res.success) {
          // 只显示本期有发生额的科目（汇总表语义），全零行过滤
          this.list = (res.data || []).filter(r => (Number(r.debitAmount) || 0) !== 0 || (Number(r.creditAmount) || 0) !== 0)
        } else if (res && res.message) {
          this.$message.warning(res.message)
        }
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    searchReset() { this.beginMoment = moment(); this.endMoment = moment(); this.searchQuery() },
    handleStoreTenantChange() { this.searchQuery() },
    rowClassName(record) { return record.isTotal ? 'gl-summary-total-row' : '' }
  }
}
</script>

<style scoped>
/deep/ .gl-summary-total-row td { background: #fafafa !important; font-weight: 600; }
</style>
